import {styled} from 'styled-components';

import {TranslateKey} from '@mavismart_frontend/components/translate';

export const MAIN_COLOR = '#D51633';
export const MAIN_COLOR_DARK = '#BA1D35';
export const SECONDARY_COLOR = '#000000';
export const GREEN_COLOR = '#34C759';
export const ORANGE_COLOR = '#FF9500';
export const DISABLED_COLOR = '#C8C8C8';
export const TEXT_MAIN_COLOR = '#545F71';
export const LIGHT_GRAY_COLOR = '#DADADA';
export const LIST_CELL_HIGHLIGHTED_COLOR = '#0000001a';
export const LIST_CELL_DEFAULT_COLOR = '#FFFFFF';
export const LIST_CELL_HOVER_COLOR = '#0000001a';
export const BORDER_COLOR = '#8A8E95';

export const BUTTON_THEME = {
  backgroundColorActive: MAIN_COLOR,
  backgroundColorHover: SECONDARY_COLOR,
  backgroundColorLoading: MAIN_COLOR_DARK,
  backgroundColorDisabled: DISABLED_COLOR,
};

export const BUTTON_THEME2 = {
  backgroundColorActive: 'white',
  backgroundColorHover: SECONDARY_COLOR,
  textColorActive: MAIN_COLOR,
  borderWidth: 1,
  borderColorActive: MAIN_COLOR,
  borderColorHover: SECONDARY_COLOR,
};

export const LINK_THEME = {
  textColorActive: TEXT_MAIN_COLOR,
  textColorHover: TEXT_MAIN_COLOR,
};

export const INPUT_THEME = {
  borderColor: BORDER_COLOR,
  focusBorderColor: TEXT_MAIN_COLOR,
  hoverBorderColor: TEXT_MAIN_COLOR,
  focusOutlineColor: LIGHT_GRAY_COLOR,
};

export const INPUT_THEME_ERROR = {
  backgroundColorActive: '#fff0f0',
  borderColor: MAIN_COLOR,
  focusBorderColor: MAIN_COLOR,
  hoverBorderColor: MAIN_COLOR,
  focusOutlineColor: '#f49c9c',
};

export const SELECT_WRAPPER_THEME = `
  border: 1px solid ${BORDER_COLOR};
  border-radius: 8px;

  &:hover {
    border-color: ${TEXT_MAIN_COLOR};
  }
`;

export const SELECT_THEME = ` border: none;
  border-radius: 8px;
  color: ${TEXT_MAIN_COLOR};
  background-color: white;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg fill='none' stroke='%23677' stroke-width='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  cursor: pointer;`;

export const MODAL_THEME = {
  background: '#fff',
  backdropColor: 'rgba(100, 99, 99, 0.5)',
  color: TEXT_MAIN_COLOR,
  noCross: true,
  props: {
    style: {
      width: '350px',
    },
  },
};

export const MODAL_TITLE_STYLE = styled.div`
  color: ${TEXT_MAIN_COLOR};
  margin: 0 auto;
`;

export const HEADER_HEIGHT = 50;
export const TAB_HEIGHT = 50;
export const TAB_TITLE_HEIGHT = 40;

export const CIRCLE_ICON_CONTAINER = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${LIGHT_GRAY_COLOR};
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
 
  cursor: pointer;
  &:hover {
    background-color: ${DISABLED_COLOR};
  }
`;

export const LOREM_IPSUM = ` Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sollicitudin ex at luctus
        feugiat. Nunc mauris justo, ultrices sit amet congue vel, lacinia eget est. Quisque
        hendrerit orci nec ornare fermentum. Ut egestas auctor metus, vel mollis tortor hendrerit
        vel. Donec dictum, mauris eget ultricies posuere, nisi lacus aliquet quam, ut fringilla quam
        lectus vel neque. Praesent suscipit quam a elit vehicula tempor. Maecenas vestibulum ligula
        id urna mollis eleifend. Maecenas tortor nulla, fermentum in euismod ac, pretium in mi. Nam
        felis arcu, facilisis nec urna non, fringilla placerat nisi. Nunc luctus, est in suscipit
        pretium, augue lorem iaculis lacus, in viverra dui massa id purus. Donec vel risus et odio
        ultrices faucibus. Etiam dapibus consequat erat in convallis.`;

export const categoryActions: Partial<Record<TranslateKey, TranslateKey>> = {
  problem_brake_replay_at_shutdown: 'problem_brake_replay_at_shutdown_action',
  detection_of_the_belt_breakage: 'detection_of_the_belt_breakage_action',
  detection_of_the_duration_of_movement_too_long:
    'detection_of_the_duration_of_movement_too_long_action',
  incorrect_max_current_setting: 'incorrect_max_current_setting_action',
  cell_test_erreur: 'cell_test_error_action',
  encoder_error_or_encoder_disconnected: 'encoder_error_or_encoder_disconnected_action',
  engine_configuration_problem_or_connection_problem:
    'engine_configuration_problem_or_connection_problem_action',
  igbt_electronic_temperature_problem: 'igbt_electronic_temperature_problem_action',
  problem_card_configation: 'problem_card_configuration_action',
  lack_of_braking_resistance: 'lack_of_braking_resistance_action',
  emergency_stop: 'emergency_stop_action',
  stop_button: 'stop_button_action',
  auto_manu: 'auto_manu_action',
  contacteur_fbk_fault: 'contacteur_fbk_fault_action',
  door_cycles_warning: 'door_cycles_warning_action',
};
